import { ConfigurationComplementsPage } from './configuration-complements/configuration-complements';
import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../globals';
import { ConfigurationTutorialSlidePage } from '../help/tutorial-slider/configuration-tutorial-slide/configuration-tutorial-slide';
import { HttpClient } from '@angular/common/http';
import { ConfigurationEstablishmentCreatePage } from './configuration-establishment/configuration-establishment-create/configuration-establishment-create';
import { ConfigurationServices } from './services';
import { ConfigurationTipsPage } from './configuration-tips/configuration-tips';
import { ConfigurationImagesPage } from './configuration-images/configuration-images';
import { ConfigurationDomainsPage } from './configuration-domains/configuration-domains';
import { ConfigurationPasswordPage } from './configuration-password/configuration-password';
import { ConfigurationUsersPage } from './configuration-users/configuration-users';
import { AddonsTriggerVersionProPage } from '../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ConfigurationUsersScreenBlockPage } from './configuration-users-screen-block/configuration-users-screen-block';
import { ConfigurationIntegrationsPage } from './configuration-integrations/configuration-integrations';
import { ConfigurationThermalPrintersPage } from './configuration-thermal-printers/configuration-thermal-printers';
import { ConfigurationRoomsPage } from './configuration-rooms/configuration-rooms';
import { ConfigurationCashsPage } from './configuration-cashs/configuration-cashs';
import { ConfigurationOrdersPage } from './configuration-orders/configuration-orders';
import { ConfigurationTicketPrintPage } from './configuration-tickets/configuration-ticket-print/configuration-ticket-print';
import { ConfigurationDeliveriesPage } from './configuration-deliveries/configuration-deliveries';
import { ConfigurationLogsPage } from './configuration-logs/configuration-logs';
import { TranslateService } from '@ngx-translate/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoginPage } from '../auth/login/login';
import { ConfigurationPaymentMethodsPage } from './configuration-payment-methods/configuration-payment-methods';
import { ConfigurationSecondDisplaImagesPage } from './configuration-second-display-images/configuration-second-display-images';
import { ConfigurationSocialPage } from './configuration-social/configuration-social';
import { ConfigurationAdvancedLogsPage } from './configuration-advanced-logs/configuration-advanced-logs';

/**
 * Generated class for the ConfigurationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration',
    templateUrl: 'configuration.html',
})
export class ConfigurationPage {

    list: any;
    transactions_list = [];

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public http: HttpClient,
        public configurationServices: ConfigurationServices,
        private alertCtrl: AlertController,
        public translate: TranslateService,
        public afAuth: AngularFireAuth,
        private toastCtrl: ToastController) {
        this.configurationServices.getRestaurant(this.globals.restaurant_uid);
        //this.getAllSuscriptionTransactions();
    }

    openSocials() {
        this.navCtrl.push(ConfigurationSocialPage);
    }

    openTuto() {
        this.navCtrl.push(ConfigurationTutorialSlidePage);
    }

    /*getAllSuscriptionTransactions() {
        const params = new HttpParams()
            .set('facturacion_id', this.globals.restaurant.facturacion_id);
        this.http.post(this.globals.analytics_path + 'pro/list/pay/customer', params, {})
            .subscribe(async res => {
                this.transactions_list = res['suscriptions'];
            });
    }*/

    openEstablishment() {
        this.globals.side_menu_config_active = "establishment";
        this.navCtrl.setRoot(ConfigurationEstablishmentCreatePage, {
            update_state: true,
            restaurant: this.configurationServices.restaurant,
        });
        this.globals.open_side_menu = false;
    }

    openTips() {
        this.globals.side_menu_config_active = 'tips';
        this.navCtrl.setRoot(ConfigurationTipsPage);
        this.globals.open_side_menu = false;
    }

    openImages() {
        this.globals.side_menu_config_active = 'images';
        this.navCtrl.setRoot(ConfigurationImagesPage);
        this.globals.open_side_menu = false;
    }

    openSecondDisplayImages() {
        this.globals.side_menu_config_active = 'second_display_images';
        this.navCtrl.setRoot(ConfigurationSecondDisplaImagesPage);
        this.globals.open_side_menu = false;
    }

    openDomains() {
        this.globals.side_menu_config_active = 'domains';
        this.globals.side_menu_active = '';
        this.navCtrl.setRoot(ConfigurationDomainsPage);
        this.globals.open_side_menu = false;
    }

    openResetPassword() {
        this.globals.side_menu_config_active = 'password';
        this.navCtrl.setRoot(ConfigurationPasswordPage);
        this.globals.open_side_menu = false;
    }

    openUsers() {
        this.globals.side_menu_config_active = 'users';
        this.navCtrl.setRoot(ConfigurationUsersPage);
        this.globals.open_side_menu = false;
    }

    openUsersScreenBlock() {
        if (!this.globals.checkLimitsByLicense('screen_block', 'block')) {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
            this.globals.side_menu_config_active = 'users_block_screen';
            this.navCtrl.setRoot(ConfigurationUsersScreenBlockPage);
        }
        this.globals.open_side_menu = false;
    }

    async openAddons() {
        //Si el restaurante tiene stripe_customer_id abrimos el url del dashboard de stripe
        if (this.globals.restaurant.stripe_customer_id != undefined && this.globals.restaurant.stripe_customer_id != '') {
            var portal_url = await this.globals.getStripeCustomerPortal();
            this.openLinkApp(portal_url['customer_portal_url']);
        }
    }

    openLinkApp(url) {
        if (this.globals.so_mobile) {
            window.location.assign(url);
        } else {
            window.open(url, '_blank');
        }
    }

    openIntegrations() {
        this.globals.side_menu_config_active = 'integrations';
        this.navCtrl.setRoot(ConfigurationIntegrationsPage);
        this.globals.open_side_menu = false;
    }

    openThermalPrinters() {
        this.globals.side_menu_config_active = 'thermal_printers';
        this.navCtrl.setRoot(ConfigurationThermalPrintersPage);
        this.globals.open_side_menu = false;
    }

    openRooms() {
        this.globals.side_menu_config_active = 'rooms';
        this.navCtrl.setRoot(ConfigurationRoomsPage);
        this.globals.open_side_menu = false;
    }

    openCashs() {
        this.globals.side_menu_config_active = 'cashs';
        this.navCtrl.setRoot(ConfigurationCashsPage);
        this.globals.open_side_menu = false;
    }

    openOrders() {
        this.globals.side_menu_config_active = 'orders';
        this.globals.side_menu_active = '';
        this.navCtrl.setRoot(ConfigurationOrdersPage);
        this.globals.open_side_menu = false;
    }

    openComplements() {
        this.globals.side_menu_config_active = 'complements';
        this.navCtrl.setRoot(ConfigurationComplementsPage);
        this.globals.open_side_menu = false;
    }

    openConfTicketPrint() {
        this.globals.side_menu_config_active = 'tickets';
        this.navCtrl.setRoot(ConfigurationTicketPrintPage, {
            headfooter: this.globals.restaurant.tickets,
        });
        this.globals.open_side_menu = false;
    }

    openConfDeliveries() {
        this.globals.side_menu_config_active = 'deliveries';
        this.navCtrl.setRoot(ConfigurationDeliveriesPage);
        this.globals.open_side_menu = false;
    }

    openLogs() {
        this.globals.side_menu_config_active = 'logs';
        this.navCtrl.setRoot(ConfigurationLogsPage);
        this.globals.open_side_menu = false;
    }

    openConfPaymentMethods() {
        this.globals.side_menu_config_active = 'payment_methods';
        this.navCtrl.setRoot(ConfigurationPaymentMethodsPage);
        this.globals.open_side_menu = false;
    }

    openAdvancedLogs() {
        this.globals.side_menu_config_active = 'advanced_logs';
        this.navCtrl.setRoot(ConfigurationAdvancedLogsPage);
        this.globals.open_side_menu = false;
    }

    logout() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-cerrar-sesion'),
            message: this.translate.instant('instant-seguro-quieres-cerrar-sesion'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.delNotTokenAndLogout();
                        this.globals.open_side_menu = false;
                    }
                }
            ]
        });
        alert.present();
    }

    async delNotTokenAndLogout() {
        //funcion que borra token
        await this.configurationServices.deleteToken(this.globals.token_user_uid, this.globals.token_current_user);
        //hacemos logout de afAuth
        this.afAuth.auth.signOut()
            .then(authData => {
                // toast message
                let toast = this.toastCtrl.create({
                    message: this.translate.instant('instant-cerrado-sesion'),
                    duration: 3000,
                    position: 'top'
                });
                toast.present();
                //
                if (this.globals.user_type != 'principal' && this.globals.user_type != 'teacher') {
                    this.globals.GAtrackView('Logout', 'Logout ', this.globals.restaurant.email, 'Logout', 'Logout', 'Logout', '');
                }
                //
                this.navCtrl.setRoot(LoginPage);
                window.location.reload();
            }, error => {
                //var errorMessage: string = error.message;
            });
    }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration.ts